import common from "../../web-sh/src/utils/common";

import other from "./other";
import cipher from "./cipher";
import permission from "./permission";
import store from "./store";
import auth from "./auth";
import storage from "./storage";
import tracking from "./tracking";
import policy from "./policy";
import socket from "./socket";

common.createEncryptedMasterPw = cipher.createEncryptedMasterPw;

common.allMenus = other.allMenus;
common.allRouters = other.allRouters;
common.openDesktopApp = other.openDesktopApp;
common.getErrorMessage = other.getErrorMessage;

common.fetchUserInfo = store.fetchUserInfo;
common.getAllCiphers = store.getAllCiphers;

common.unlockToVault = auth.unlockToVault;
common.remakeBackupPWL = auth.remakeBackupPWL;

common.getDeviceId = storage.getDeviceId;
common.syncDataByWs = socket.syncDataByWs;

common.checkingHandleAttachment = permission.checkingHandleAttachment;

export default {
  ...common,
  ...other,
  ...cipher,
  ...permission,
  ...store,
  ...auth,
  ...storage,
  ...tracking,
  ...policy
}